"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouter = require("react-router");

var _Route = _interopRequireDefault(require("../Route"));

var _auth = require("../../../modules/auth");

var PrivateRoute = function PrivateRoute(props) {
  var component = props.component,
      auth = props.auth,
      subroutes = props.subroutes,
      otherProps = (0, _objectWithoutPropertiesLoose2.default)(props, ["component", "auth", "subroutes"]);
  var authContext = (0, _auth.useAuth)();
  return /*#__PURE__*/_react.default.createElement(_reactRouter.Route, (0, _extends2.default)({}, otherProps, {
    render: function render(routeProps) {
      var AuthComponent = authContext.AuthComponent;

      if (auth.AuthComponent) {
        AuthComponent = auth.AuthComponent;
      } else if (authContext.AuthComponent) {
        AuthComponent = authContext.AuthComponent;
      }

      if (!authContext.authenticated) {
        return /*#__PURE__*/_react.default.createElement(AuthComponent, {
          code: "401",
          authContext: authContext
        });
      } else if (auth.forAllRoles && !authContext.hasAllRoles(auth.forAllRoles)) {
        return /*#__PURE__*/_react.default.createElement(AuthComponent, {
          code: "403",
          authContext: authContext
        });
      } else if (auth.forSomeRole && !authContext.hasSomeRole(auth.forSomeRole)) {
        return /*#__PURE__*/_react.default.createElement(AuthComponent, {
          code: "403",
          authContext: authContext
        });
      }

      if (subroutes) {
        var Component = component;
        var routes = subroutes.map(function (subrouteProps, index) {
          var path = subrouteProps.path,
              moreSubrouteProps = (0, _objectWithoutPropertiesLoose2.default)(subrouteProps, ["path"]);
          return /*#__PURE__*/_react.default.createElement(_Route.default, (0, _extends2.default)({}, moreSubrouteProps, {
            key: index,
            path: "" + routeProps.match.path + subrouteProps.path
          }));
        });
        return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, routeProps, {
          routes: routes
        }));
      }

      return /*#__PURE__*/_react.default.createElement(_Route.default, (0, _extends2.default)({}, otherProps, {
        component: component
      }));
    }
  }));
};

PrivateRoute.propTypes = {
  authContext: _propTypes.default.object,
  component: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
  subroutes: _propTypes.default.array,
  auth: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
    AuthComponent: _propTypes.default.elementType,
    forAllRoles: _propTypes.default.arrayOf(_propTypes.default.string),
    forSomeRole: _propTypes.default.arrayOf(_propTypes.default.string)
  })])
};
var _default = PrivateRoute;
exports.default = _default;